'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';
import slick from 'slick-carousel';
import wt from 'widowtamer';

export default class HeroCarousel extends Component {
    constructor(el) {
        super(el);
        this.$container = $(this.container);
        this.init();
    }

    init() {
        this.$inner = this.$container.find('.js-hero-carousel-inner');
        this.$dotsContainer = this.$container.find('.js-hero-carousel-dots');

        if (!this.$inner.length || !this.$dotsContainer.length) {
            this.$container.addClass('js-init-errors');
            return false;
        }

        this.$inner.slick({
            arrows: false,
            dots: true,
            appendDots: this.$dotsContainer,
            useTransform: false,
            speed: 500,
            autoplay: true,
            autoplaySpeed: 2500,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true
        });

        wt.fix({elements: '.js-widow-fix', chars: 10, method: 'nbsp'});
    }
}



// WEBPACK FOOTER //
// ./app/components/hero-carousel/js/generic.hero-carousel.js